import { mapState } from "vuex";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IState } from "@/store";
import { ISegment } from "@/models/segments";
import { DataModules } from "@/store/modules/data";
import { IFilter } from "@/models/tables";
import {
  ApiOperators,
  FILTER_ARRAY_VALUES_SEPARATOR,
  FILTER_TYPES_WITH_ARRAY_VALUES,
  FilterTypes,
  ROUTER_OPERATOR_SEPARATOR
} from "@/data/table";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { getOperatorFromValueAndApiOperator } from "@/helpers/table";

@Component({
  computed: {
    ...mapState({
      segment(state: IState, getters) {
        return getters[`data/single`]({
          id: this.segmentId,
          storeModule: DataModules.SEGMENTS
        });
      }
    })
  }
})
export default class SegmentTableMixin extends Mixins(
  FilteringSortingTableStore
) {
  public segment!: ISegment;

  @Prop({ default: "" })
  public segmentId!: ISegment["id"];

  public loading = false;
  public isLoading = false;

  public get constSegmentFilters(): IFilter[] {
    const filters = this.$_.get(this.segment, "params.filter", {});

    if (this.$_.isEmpty(filters)) {
      return [];
    }

    return this.isLoading
      ? []
      : (this.$_.map(filters, this.deSerialiseSegmentFilter) as IFilter[]);
  }

  public deSerialiseSegmentFilter(value, filterKeyAndOperator): IFilter {
    const filterParams: string[] = filterKeyAndOperator.split(
      ROUTER_OPERATOR_SEPARATOR
    );
    const filter: IFilter = (this.$_.find(this.filters, [
      "key",
      filterParams[0]
    ]) || {}) as IFilter;
    const type = this.$_.get(filter, "type", FilterTypes.STRING);
    if (FILTER_TYPES_WITH_ARRAY_VALUES.includes(type)) {
      value = value.split(FILTER_ARRAY_VALUES_SEPARATOR);
    }

    return {
      ...filter,
      key: filterParams[0],
      value: value,
      operator: getOperatorFromValueAndApiOperator(
        value,
        filterParams[1] as ApiOperators
      )
    };
  }
}
